module.exports = __webpack_public_path__ + "static/media/Dr3.d9d10693.jpg";